import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
  SET_REPARTIDORS_LIST,
  SET_REPARTIMENTS_LIST,
  SET_DELIVERIES_LIST,
  OPEN_DELIVERY_FORM,
  CLOSE_DELIVERY_FORM,
  EDIT_SELECTED_DELIVERY,
  DELIVERY_FORM_TOGGLE_LOADING,
  SET_DEALERS_LIST,
  SET_SHOPCART_LIST,
  ADD_NEW_SHOPCART,
  DELETE_SHOPCART,
  SHOPCART_FORM_TOOGLE_LOADING,
  SET_ARTICLES_LIST,
  SET_INVOICES_LIST,
  SET_DELIVERYNOTES_LIST,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers('USER');

export const users = userReducers.list;
export const usersForm = userReducers.form;

const equipmentReducers = createCrudReducers('EQUIPMENT');

export const equipments = equipmentReducers.list;
export const equipmentsForm = equipmentReducers.form;
const workorderReducers = createCrudReducers('WORKORDER');

export const workorders = workorderReducers.list;
export const workordersForm = workorderReducers.form;
const singupReducers = createCrudReducers('SINGUP');

export const singups = singupReducers.list;
export const singupsForm = singupReducers.form;
const petitionReducers = createCrudReducers('PETITION');

export const petitions = petitionReducers.list;
export const petitionsForm = petitionReducers.form;
const configurationReducers = createCrudReducers('CONFIGURATION');

export const configurations = configurationReducers.list;
export const configurationsForm = configurationReducers.form;

const repartimentReducers = createCrudReducers('REPARTIMENT');

export const repartiments = repartimentReducers.list;
export const repartimentsForm = repartimentReducers.form;

/* REPARTIDORS */
export const repartidors = handleActions(
  {
    [SET_REPARTIDORS_LIST]: (state, action) => action.payload,
  },
  null
);

/* REPARTIMENTS DATA */
export const repartimentsData = handleActions(
  {
    [SET_REPARTIMENTS_LIST]: (state, action) => action.payload,
  },
  null
);

/* DELIVERIES */
export const deliveries = handleActions(
  {
    [SET_DELIVERIES_LIST]: (state, action) => action.payload,
  },
  null
);

export const deliveriesForm = handleActions(
  {
    [OPEN_DELIVERY_FORM]: (state) => ({ ...state, show: true, data: null }),
    [CLOSE_DELIVERY_FORM]: (state) => ({ ...state, show: false, data: null }),
    [EDIT_SELECTED_DELIVERY]: (state, action) => ({ ...state, show: true, data: action.payload }),
    [DELIVERY_FORM_TOGGLE_LOADING]: (state) => ({ ...state, loading: !state.loading }),
  },
  { show: false, data: null, loading: false }
);

/* DEALERS */
export const dealers = handleActions(
  {
    [SET_DEALERS_LIST]: (state, action) => action.payload,
  },
  null
);

/* SHOPCARTS */
export const shopCarts = handleActions(
  {
    [SET_SHOPCART_LIST]: (state, action) => action.payload,
    [ADD_NEW_SHOPCART]: (state, action) => {
      const newState = {
        ...state,
        [action.payload._id]: action.payload,
      };
      return newState;
    },
    [DELETE_SHOPCART]: (state, action) => {
      action.payload.forEach((id) => {
        delete state[id];
      });
      return { ...state };
    },
  },
  null
);

export const shopCartsForm = handleActions(
  {
    [SHOPCART_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

/* ARTICLES */
export const articles = handleActions(
  {
    [SET_ARTICLES_LIST]: (state, action) => action.payload,
  },
  null
);

/* INVOICES */
export const invoices = handleActions(
  {
    [SET_INVOICES_LIST]: (state, action) => action.payload,
  },
  null
);

/* DELIVERY NOTES */
export const deliveryNotes = handleActions(
  {
    [SET_DELIVERYNOTES_LIST]: (state, action) => action.payload,
  },
  null
);
